import * as React from 'react';
import { Button, ButtonStyle, IButtonProps } from './Button';
import { Classes } from '../index';
import classNames from 'classnames';
type NavbarProps = Omit<IButtonProps, 'danger' | 'inverse' | 'style'> & {
  style?: Exclude<ButtonStyle, 'primary'>;
};
export const NavbarButton: React.FC<NavbarProps> = ({
  children,
  className,
  style,
  ...props
}) => {
  return (
    <Button
      {...props}
      className={classNames(className, Classes.BUTTON_NAVBAR, {
        [Classes.BUTTON_LINK_NAVBAR]: style === 'link',
      })}
      noFocus
    >
      {children}
    </Button>
  );
};
